import React, { useEffect, useMemo, useState } from 'react';

export default function InlineButtonLoader({ label = 'Verwerken...', progress = null }) {
  const hasProgress = Number.isFinite(progress);
  const clampedProgress = useMemo(() => {
    if (!hasProgress) return null;
    return Math.max(0, Math.min(100, Math.round(progress)));
  }, [hasProgress, progress]);

  const [simulatedProgress, setSimulatedProgress] = useState(10);

  useEffect(() => {
    if (hasProgress) return;

    setSimulatedProgress(10);
    const intervalId = setInterval(() => {
      setSimulatedProgress((prev) => {
        if (prev >= 96) return 96;
        if (prev < 55) return prev + 4;
        if (prev < 85) return prev + 1.5;
        return prev + 0.5;
      });
    }, 180);

    return () => clearInterval(intervalId);
  }, [hasProgress, label]);

  const effectiveProgress = hasProgress ? clampedProgress : Math.round(simulatedProgress);

  return (
    <span className="inline-btn-loader" aria-live="polite" aria-label={label}>
      <span className="inline-btn-loader-wheel" aria-hidden="true" />
      <span className="inline-btn-loader-bar" aria-hidden="true">
        <span
          className="inline-btn-loader-bar-fill determinate"
          style={{ width: `${effectiveProgress}%` }}
        />
      </span>
      <span className="inline-btn-loader-percent">{effectiveProgress}%</span>
      <span>{label}</span>
    </span>
  );
}
